import { render, staticRenderFns } from "./TrialInfoBox.vue?vue&type=template&id=1cbca0ad"
import script from "./TrialInfoBox.vue?vue&type=script&lang=js"
export * from "./TrialInfoBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports